import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import DownArrow from '../components/Svg/DownArrow';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;

    select:focus {
        outline: none;
        border: solid 1px #008eff;
    }
`;

const Select = styled.select`
    height: 36px;
    border-radius: 2px;
    border: solid 1px ${props => (props.touched && props.error ? '#ff245e' : '#f1f1ee')};
    font-family: Averta;
    font-size: 14px;
    line-height: 110%;
    padding: 0.571em;
    color: ${props => (props.touched || props.value ? '#333' : '#a59f9f')};
    background: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    @media (max-width: 30em) {
        margin-left: 0;
        margin-right: 0;
    }

    &.default {
        color: #a59f9f;

        &.changed {
            color: #333;
        }
    }

    option {
        color: #333;

        &:first-child {
            color: #a59f9f;
        }
    }

    + svg {
        position: absolute;
        ${props => (props.hasInfoText ? 'top: 28px;' : 'bottom: 10px;')};
        right: 15px;
        pointer-events: none;
        cursor: pointer;
    }
`;

const LabelContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Error = styled.div`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-align: right;
    color: #ff245e;
    text-transform: uppercase;
`;

const Label = styled.label`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 0.5em;
`;

const LabelInfo = Label.extend`
    text-transform: none;
    letter-spacing: 0;
    margin-top: 6px;
    margin-bottom: 0;
    font-weight: 500;
    font-size: 8.5px;
    line-height: 1.4;
`;

class DropDownSelect extends React.Component {
    constructor(props) {
        super(props);
        this.focusTextInput = this.focusTextInput.bind(this);
    }

    componentDidMount() {
        if (this.props.autoFocus) {
            this.focusTextInput();
        }
    }

    focusTextInput() {
        // timeout is not working on iOS Safari
        // if (this.props.autoFocusTimeout) {
        //   setTimeout(() => {
        //     findDOMNode(this.textInput).focus()
        //   }, this.props.autoFocusTimeout)
        // } else {
        //   findDOMNode(this.textInput).focus()
        // }

        this.textInput.focus();
    }

    render() {
        return (
            <Container>
                <LabelContainer>
                    <Label htmlFor="">{this.props.label}</Label>
                    {this.props.meta.touched && this.props.meta.error && (
                        <Error>{this.props.meta.error}</Error>
                    )}
                </LabelContainer>
                <Select
                    className={this.props.class}
                    hasInfoText={
                        this.props.infoText !== '' && this.props.infoText !== undefined
                    }
                    {...this.props.input}
                    {...this.props.meta}
                >
                    <option value="" disabled>
                        {this.props.defaultOption}
                    </option>
                    {this.props.countryCodeDropdown
                        ? this.props.options.map((option, i) => (
                              <option value={option.code} key={i}>
                                  {option.value}
                              </option>
                          ))
                        : this.props.options.map(option => (
                              <option value={option} key={option}>
                                  {option}
                              </option>
                          ))}
                </Select>
                <DownArrow />
                {this.props.infoText && <LabelInfo>{this.props.infoText}</LabelInfo>}
            </Container>
        );
    }
}

DropDownSelect.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    primary: PropTypes.bool,
    autoFocus: PropTypes.bool,
    maxLength: PropTypes.number,
    autoFocusTimeout: PropTypes.number,
    placeholder: PropTypes.string,
    autocomplete: PropTypes.string,
    inputColor: PropTypes.string,
    options: PropTypes.array,
    defaultOption: PropTypes.string,
    class: PropTypes.string,
    infoText: PropTypes.string,
    countryCodeDropdown: PropTypes.bool
};

export default DropDownSelect;



// WEBPACK FOOTER //
// ./src/components/DropDownSelect.jsx